import { v4 as uuidv4 } from 'uuid';

const isDataLayerAvailable = () => {
    return typeof window.dataLayer !== 'undefined';
};

const resetDataLayer = () => {
    window.dataLayer.push({ event_data: null });
};

const getEventGroup = (eventName) => {
    let eventGroup;
    switch (eventName) {
    case 'submit_contact_form':
        eventGroup = 'contact';
        break;
    default:
        eventGroup = 'lead';
    }

    return eventGroup;
};

export const pushDataLayerSearchQuery = (query) => {
    if (!isDataLayerAvailable()) return;

    resetDataLayer();

    window.dataLayer.push({
        'event': 'custom_event',
        'event_data': {
            'event_name': 'search_results',
            'search_term': `${query ?? ''}`,
            'event_group': 'standard',
        },
    });
};

export const pushFormDataLayer = (eventName) => {
    if (!isDataLayerAvailable()) return;

    resetDataLayer();

    const dataLayerObject = {
        'event': 'custom_event',
        'event_data': {
            'event_name': `${eventName}`,
            'event_group': getEventGroup(eventName),
        },
    };

    if (eventName !== 'submit_newsletter') {
        dataLayerObject.event_data['lead_id'] = `${uuidv4()}`;
    }

    window.dataLayer.push(dataLayerObject);
};

const pushTopHeaderClick = (selectItem, isMobile = false) => {
    if (!isDataLayerAvailable()) return;

    resetDataLayer();

    window.dataLayer.push({
        'event': 'custom_event',
        'event_data': {
            'event_name': 'select_header',
            'select_item': selectItem,
            'event_group': 'measurement',
            'mobile_variant': isMobile,
        },
    });
};

const pushMainHeaderClick = (selectItem, isMobile = false) => {
    if (!isDataLayerAvailable()) return;

    resetDataLayer();

    window.dataLayer.push({
        'event': 'custom_event',
        'event_data': {
            'event_name': 'select_menu',
            'select_item': selectItem,
            'event_group': 'measurement',
            'mobile_variant': isMobile,
        },
    });
};

const pushFooterClick = (selectItem) => {
    if (!isDataLayerAvailable()) return;

    resetDataLayer();

    window.dataLayer.push({
        'event': 'custom_event',
        'event_data': {
            'event_name': 'select_footer',
            'select_item': selectItem,
            'event_group': 'measurement',
        },
    });
};

export const pushSelectedItemToDatalayer = (action, value, isMobile = false) => {
    if (!action || !value) return;

    switch (action) {
    case 'select_menu':
        pushMainHeaderClick(value, isMobile);
        break;
    case 'select_header':
    case 'select_meta_header':
        pushTopHeaderClick(value, isMobile);
        break;
    case 'select_footer':
        pushFooterClick(value);
        break;
    }
};

const pushDataLayersOnLoad = () => {
    // Meta header, main navigation, footer
    const datalayerContainers = document.querySelectorAll('header, .main-header-top, footer');
    if (datalayerContainers) {
        datalayerContainers.forEach((container) => {
            container.addEventListener('click', (event) => {
                const actionElement = event.target.closest('[data-push-action]');
                if (!actionElement) return;

                const action = actionElement.dataset.pushAction;

                let value;
                if (action === 'select_meta_header') {
                    value = event.target.textContent;
                } else {
                    value = actionElement.dataset.pushValue;
                }

                pushSelectedItemToDatalayer(action, value, false);
            });
        });
    }
};

pushDataLayersOnLoad();
